/**
 * Bundle 169 hotfix 2 - pure threshold + summary helpers for the
 * PodStabilityTile. Extracted so unit tests can import them without
 * dragging the shadcn Dialog dependency graph into jest.
 */
export const AMBER_MIN_MS = 1500;
export const RED_MIN_MS = 3000;

export const readMaxDetectorMs = (report) => {
  const timings = report?.health_cards_cache?.detector_timings_ms || {};
  const values = Object.values(timings).filter(
    (v) => typeof v === 'number');
  if (values.length === 0) return null;
  return Math.max(...values);
};

export const countSlowDetectors = (report, threshold = AMBER_MIN_MS) => {
  const timings = report?.health_cards_cache?.detector_timings_ms || {};
  return Object.values(timings).filter(
    (v) => typeof v === 'number' && v >= threshold).length;
};

/**
 * Bundle 170 hotfix nice-to-have - return the slowest detector name
 * (or null) so the tile can hint which detector is chronically slow.
 * Empty timings map -> null.
 */
export const slowestDetectorName = (report) => {
  const timings = report?.health_cards_cache?.detector_timings_ms || {};
  const entries = Object.entries(timings)
    .filter(([, v]) => typeof v === 'number');
  if (entries.length === 0) return null;
  entries.sort((a, b) => b[1] - a[1]);
  return entries[0][0];
};

export const toneFor = (maxMs, slow) => {
  if (maxMs !== null && maxMs > RED_MIN_MS) return 'red';
  if ((maxMs !== null && maxMs > AMBER_MIN_MS) || slow >= 1) return 'amber';
  return 'green';
};
